<template>
  <div v-if="isManager">
    <section id="user">
      <h2 v-if="!isPrivateUser">企業情報入力</h2>
      <h2 v-else>会員連絡先入力</h2>
      <div class="input_list">
        <ul>
          <li v-if="!isPrivateUser">
            <div>
              <span>{{label.corpName}}</span>
              <span class="important small_text">必須</span>
            </div>
            <input type="text" v-model.trim="corpForm.corpName" maxlength="32"/>
            <div v-if="errors.corpName" class="error_text">{{errors.corpName}}</div>
          </li>
          <li v-if="!isPrivateUser">
            <div>
              <span>{{label.corpBranchName}}</span>
            </div>
            <input type="text" v-model.trim="corpForm.corpBranchName" maxlength="32"/>
            <div v-if="errors.corpBranchName" class="error_text">{{errors.corpBranchName}}</div>
          </li>
          <li v-if="!isPrivateUser">
            <div>
              <span>{{label.email}}</span>
              <span class="important small_text">必須</span>
              <span class="small_p">仮登録したアドレスと間違いがないかご確認ください。</span>
            </div>
            <input type="text" v-model.trim="corpForm.email" placeholder="****@domans.co.jp" v-bind:disabled="!isEdit" maxlength="128"/>
            <div v-if="errors.email" class="error_text">{{errors.email}}</div>
          </li>
          <li>
            <div>
              <span>{{label.tel}}</span>
              <span class="small_p">（半角数値、ハイフン不要）</span>
              <span class="important small_text">必須</span>
            </div>
            <input type="text" v-model.trim="corpForm.tel" @keypress="validateNumber" @input="corpForm.tel=inputRestNumber($event)" oninput="if(value.length>11)value=value.slice(0,11)" placeholder="0123456789" maxlength="11"/>
            <div v-if="errors.tel" class="error_text">{{errors.tel}}</div>
          </li>
          <li>
            <div>
              <span>{{label.fax}}</span>
              <span class="small_p">（半角数値、ハイフン不要）</span>
            </div>
            <input type="text" v-model.trim="corpForm.fax" @keypress="validateNumber" @input="corpForm.fax=inputRestNumber($event)" maxlength="16"/>
            <div v-if="errors.fax" class="error_text">{{errors.fax}}</div>
          </li>
          <li>
            <div>
              <span>{{label.postcd}}</span>
              <span class="small_p">（半角数値、ハイフン不要）</span>
              <span class="important small_text">必須</span>
            </div>
            <input type="text" v-model.trim="corpForm.postcd" @keypress="validateNumber" @input="corpForm.postcd=inputRestNumber($event)" @blur="addressCompletion"  maxlength="7"/>
            <div v-if="errors.postcd" class="error_text">{{errors.postcd}}</div>
          </li>
          <li class="input_text2">
            <div>
              <span>{{label.state}}</span>
              <span class="important small_text">必須</span>
            </div>
            <div>
              <input type="text" v-model.trim="corpForm.state" placeholder="都道府県" maxlength="32"/>
              <span class="space"></span>
              <input type="text" v-model.trim="corpForm.city" placeholder="市区町村" maxlength="32"/>
            </div>
            <div v-if="errors.state" class="error_text">{{errors.state}}</div>
          </li>
          <li>
            <div>
              <span>{{label.street}}</span>
              <span class="important small_text">必須</span>
            </div>
            <input type="text" v-model.trim="corpForm.street"  maxlength="32"/>
            <div v-if="errors.street" class="error_text">{{errors.street}}</div>
          </li>
          <li v-if="!isEdit">
            <div>
              <span>{{label.inviteCode}}</span>
            </div>
            <input type="text" v-model.trim="corpForm.inviteCode"  maxlength="16"/>
            <div v-if="inviteErrMessage" class="error_text">{{inviteErrMessage}}</div>
          </li>
          <div v-if="Object.keys(errors).length > 0" class="error_text">入力内容にエラーがあります。項目をご確認の上、もう一度入力してください。</div>
        </ul>
      </div>
    </section>
  </div>
</template>
<script>
import * as Check from '../../../utils/Check'
import * as FormUtil from '../../../utils/FormUtil'
import {CORP_TYPE, INFO_SRC} from '../../constants/TypeEc'
import UseRuleDetial from '../common/DcUseRuleDetial'

export default {
  name: 'CorpInput',
  components: {
    'dd-user-rule-detial': UseRuleDetial
  },
  props: {
    isEdit: Boolean,
    corpForm: Object,
    isManager: {
      type: Boolean,
      default: false
    },
    isPrivateUser: {
      type: Boolean,
      default: false
    },
    inviteErrMessage: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      errors: {},
      label: {
        corpName: '会社名',
        corpBranchName: '支店名・営業所名',
        email: 'メールアドレス',
        tel: '電話番号',
        fax: 'FAX',
        postcd: '郵便番号',
        state: '住所',
        street: '以下住所',
        inviteCode: '招待コード'
      },
      isExistPostcd: false
    }
  },
  computed: {
    corpTypeList: function () {
      return Object.keys(CORP_TYPE)
        .map(e => CORP_TYPE[e])
    },
    infoSrcList: function () {
      return Object.keys(INFO_SRC)
        .map(e => INFO_SRC[e])
    }
  },
  methods: {
    confirm: function () {
      // エラーメッセージのクリア
      this.errors = {}

      // 入力チェック
      this.validateRequire()
      if (Object.keys(this.errors).length !== 0) {
        this.$forceUpdate()
        return false
      }
      this.validateFormat()
      if (Object.keys(this.errors).length !== 0) {
        this.$forceUpdate()
        return false
      }

      if (this.isExistPostcd === false) {
        this.errors['postcd'] = this.label.postcd + 'が間違っています'
        this.$forceUpdate()
        return false
      }

      return true
    },
    validateRequire: function () {
      if (!this.isPrivateUser) {
        if (!this.corpForm.corpName) {
          this.errors['corpName'] = this.label.corpName + 'は必須項目です。'
        }
        if (!this.corpForm.email) {
          this.errors['email'] = this.label.email + 'は必須項目です。'
        }
      }
      if (!this.corpForm.tel) {
        this.errors['tel'] = this.label.tel + 'は必須項目です。'
      }
      if (!this.corpForm.postcd) {
        this.errors['postcd'] = this.label.postcd + 'は必須項目です。'
      }
      if (!this.corpForm.state || !this.corpForm.city) {
        this.errors['state'] = this.label.state + 'は必須項目です。'
      }
      if (!this.corpForm.street) {
        this.errors['street'] = this.label.street + 'は必須項目です。'
      }
    },
    validateFormat: function () {
      if (!Check.isMail(this.corpForm.email)) {
        this.errors['email'] = 'メールアドレスの形式ではありません。'
      }
      if (!Check.isTel(this.corpForm.tel)) {
        this.errors['tel'] = this.label.tel + 'は半角数値かつ、10～11文字で入力してください。'
      }
      if (this.corpForm.fax) {
        if (this.corpForm.fax.length > 0 && !Check.isNumber(this.corpForm.fax)) {
          this.errors['fax'] = this.label.fax + 'は半角数値で入力してください。'
        }
      }
      if (!Check.isPostCd(this.corpForm.postcd)) {
        this.errors['postcd'] = this.label.postcd + 'は半角数値で入力してください。'
      }
    },
    setErrorMessage: function (messages) {
      if (messages.email) {
        this.errors['email'] = messages.email
        this.$forceUpdate()
      }
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      if (str.length <= 0) {
        return ''
      }
      return str
    },
    addressCompletion: function () {
      FormUtil.addressCompletion(this.corpForm.postcd, (address) => {
        this.$set(this.corpForm, 'state', address.state)
        this.$set(this.corpForm, 'city', address.city)
        this.$set(this.corpForm, 'street', address.street)
        if (this.corpForm.postcd.length > 0 && (!this.corpForm.state || !this.corpForm.city)) {
          this.isExistPostcd = false
        } else {
          this.isExistPostcd = true
        }
      })
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.isExistPostcd = FormUtil.isExistPostcd(this.corpForm.postcd)
    })
  },
  created () {
  }
}
</script>
<style src="../../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/hakotan/components/user/DcCorpInfo.vue